// Zentralisierte Settings für Ride/Explore-Mode.
//
// Werte werden per usePreference in localStorage persistiert und über alle
// Komponenten synchronisiert. Defaults:
//   - Ride-Zoom:    16 (höchste Stufe, so wie User-Wunsch beim Locate-Tap)
//   - Explore-Zoom: 14 (ganzer Trail typischerweise sichtbar)
//
// Auto-Follow im Ride-Mode ist NICHT einstellbar — laut User muss es immer
// an sein (FYI-Kommentar in seinen Wünschen). Deswegen kein Setting dafür.

import { useNumberPreference } from './usePreference';

export const PREF_RIDE_ZOOM = 'adt_ride_zoom';
export const PREF_EXPLORE_ZOOM = 'adt_explore_zoom';

// map.maxZoom in MapView ist 20 (Batch 7: "viel mehr reinzoomen können"). Der
// Ride-Mode-Slider darf bis dahin gehen — bei Close-Single-Track auf engen
// Kehren ist z18+ gelegentlich hilfreich. Default bleibt aber bei 16 (crisper
// Look aus Native-PMTile-Zoom), der User kann explizit aufdrehen.
export const RIDE_ZOOM_MIN = 13;
export const RIDE_ZOOM_MAX = 20;
export const RIDE_ZOOM_DEFAULT = 16;

// Explore darf weiter rauszoomen — z.B. 11 zeigt fast ganz Liguria. Nach oben
// ebenfalls bis 20 damit das Setting das gesamte Map-Zoom-Spektrum abdeckt.
export const EXPLORE_ZOOM_MIN = 10;
export const EXPLORE_ZOOM_MAX = 20;
export const EXPLORE_ZOOM_DEFAULT = 14;

export function useRideZoom(): [number, (v: number) => void] {
  return useNumberPreference(PREF_RIDE_ZOOM, RIDE_ZOOM_DEFAULT);
}

export function useExploreZoom(): [number, (v: number) => void] {
  return useNumberPreference(PREF_EXPLORE_ZOOM, EXPLORE_ZOOM_DEFAULT);
}
